import type { Dictionnaire } from '../type';
import { compte } from './pluriel';

export const carte: Dictionnaire['carte'] = {
  ecran: {
    voirTout: 'عرض الكل',
    dansLaZone: 'في هذه المنطقة',
    impossible: 'تعذّر ذلك الآن.',
    recherchePosition: 'جارٍ تحديد موقعك…',
    activerLocalisation: 'فعّل تحديد الموقع لترى نفسك على الخريطة',
    unSansAdresse: 'فعالية واحدة بلا عنوان دقيق لا تظهر على الخريطة.',
    revenir: 'العودة إلى موقعي',
    personneInscrit: 'لم يسجّل أحد بعد',
    inscrit: 'أنت مسجّل',
    demandeEnvoyee: 'تم إرسال الطلب',
    listeAttente: 'الانضمام إلى قائمة الانتظار',
    rejoindre: 'الانضمام إلى هذه الفعالية',
    plusTard: 'ربما لاحقًا',
    aucun: 'لا توجد فعاليات',
    un: 'فعالية واحدة',
    videCarte: 'لا توجد فعاليات على الخريطة بعد. ستظهر الجديدة هنا تلقائيًا.',
    videZone: 'لا شيء في هذا الجزء من الخريطة. صغّر الخريطة أو حرّكها لرؤية غيره.',
    sansAdresse: (n: number) => `${compte(n, 'فعالية واحدة', 'فعاليتان', 'فعاليات', 'فعالية')} بلا عنوان دقيق لا تظهر على الخريطة.`,
    participants: (n: number) => compte(n, 'مشارك واحد', 'مشاركان', 'مشاركين', 'مشاركًا'),
    memeEndroit: (n: number) => `${compte(n, 'فعالية واحدة', 'فعاليتان', 'فعاليات', 'فعالية')} في المكان نفسه`,
    plusieurs: (n: number) => compte(n, 'فعالية واحدة', 'فعاليتان', 'فعاليات', 'فعالية'),
  },
  apple: {
    pasOuverte: 'تعذّر فتح خريطة Apple.',
    pasChargee: 'تعذّر تحميل خريطة Apple.',
  },
  libre: {
    pasAffichee: 'تعذّر عرض الخريطة على هذا الجهاز.',
    pasChargee: 'تعذّر تحميل الخريطة. تحقّق من اتصالك.',
  },
  placer: {
    titre: 'التحديد داخل الحرم',
    deplacer: 'اسحب العلامة لضبطها.',
    toucher: 'اضغط على الخريطة حيث تقام الفعالية.',
    placerIci: 'ضعها هنا',
  },
  pastilles: {
    maPosition: 'موقعي',
    sortie: (titre: string, categorie: string, spontanee: boolean) =>
      `${titre}، ${categorie}${spontanee ? '، عفوية' : ''}`,
    groupe: (n: number) => `${compte(n, 'فعالية واحدة', 'فعاليتان', 'فعاليات', 'فعالية')} في هذا المكان`,
  },
  maquette: {
    pasAffichee: 'تعذّر عرض المجسّم على هذا الجهاز.',
  },
  placerMaquette: {
    pasAffichee: 'لا يمكن عرض المجسّم على هذا الجهاز.',
    deplacer: 'اضغط في مكان آخر لنقلها.',
    toucher: 'اضغط على المجسّم حيث تقام الفعالية.',
  },
  apercu: {
    credits: '© OpenStreetMap · OpenFreeMap',
    carteDuLieu: (lieu: string) => `خريطة المكان: ${lieu}`,
  },
};
